// ProposalDetailMobile.tsx
import React from "react";
import { Card, Col, Divider, Row, Space, Tag, Typography } from "antd";
import { AppBarCustom } from "../../../components/AppBarCustom";
import { ButtonCustom } from "../../../components/ButtonCustom";
import { ProposalDetail } from "../model/proposalDetail.ui";
import { formatDate, formatDateDDMM } from "../../../utils/constants";
import { getStatusConfig } from "../components/proposalHelpers";

const { Text, Title } = Typography;

interface ProposalDetailMobileProps {
    proposal?: ProposalDetail;
    handleBack: () => void;
    onCreateOrder?: () => void;
}

export const ProposalDetailMobile: React.FC<ProposalDetailMobileProps> = ({
    proposal,
    handleBack,
    onCreateOrder
}) => {
    return (
        <div style={{ width: '100%', minHeight: '100vh', backgroundColor: '#F8F9FA', position: 'relative', paddingBottom: 80 }}>
            <AppBarCustom title="提案詳細" /* Chi tiết đề xuất */ handleBack={handleBack} />

            <div style={{ padding: '16px' }}>
                <Card
                    variant="borderless"
                    style={{ borderRadius: 16, marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
                    styles={{ body: { padding: 16 } }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                        <Title level={4} style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#111827' }}>
                            {proposal?.propose_code}
                        </Title>
                        {proposal?.status && (
                            <Tag color={getStatusConfig(proposal.status).color} icon={getStatusConfig(proposal.status).icon}>
                                {getStatusConfig(proposal.status).label}
                            </Tag>
                        )}
                    </div>
                    <Space size={4} orientation="vertical" style={{ width: "100%" }}>
                        <Text style={{ color: '#6B7280', fontSize: 14 }}>
                            有効期間: {/* Thời gian: */} <Text strong style={{ color: '#111827', fontWeight: 600 }}>{formatDate(proposal?.effective_from)} ~ {formatDate(proposal?.effective_to)}</Text>
                        </Text>
                        <Text style={{ color: '#6B7280', fontSize: 14 }}>
                            送信者: {/* Người gửi: */} <Text strong style={{ color: '#111827', fontWeight: 600 }}>{proposal?.recipient_name}</Text>
                        </Text>
                    </Space>
                </Card>

                <Title level={5} style={{ margin: '0 0 12px 0', fontSize: 16, fontWeight: 700, color: '#111827' }}>
                    提案商品一覧 ({proposal?.items?.length || 0}) {/* Danh sách sản phẩm đề xuất */}
                </Title>

                <Space size={12} orientation="vertical" style={{ width: "100%" }}>
                    {proposal?.items?.map((item, index) => {
                        const totalQuantity = item.schedules?.reduce((acc, e) => acc + Number(e.quantity), 0) || 0;
                        const hasSchedules = item.schedules && item.schedules.length > 0;

                        return (
                            <Card
                                key={index}
                                variant="borderless"
                                style={{ borderRadius: 16, width: "100%", boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
                                styles={{ body: { padding: 16 } }}
                            >
                                <Space size={8} orientation="vertical" style={{ width: "100%" }}>
                                    <Row justify="space-between" align="top">
                                        <Col span={17}>
                                            <Text strong style={{ fontSize: 16, color: '#111827', display: 'block' }}>
                                                {item.product_name}
                                            </Text>
                                        </Col>
                                        <Col span={7} style={{ textAlign: 'right' }}>
                                            <Text strong style={{ color: '#B91C1C', fontSize: 16 }}>
                                                {typeof item.price === 'number' ? `¥${item.price}` : item.price}
                                            </Text>
                                        </Col>
                                    </Row>

                                    {item.origin && (
                                        <Text style={{ color: '#9CA3AF', fontSize: 13, display: 'block' }}>
                                            {item.origin}
                                        </Text>
                                    )}

                                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', color: '#6B7280', fontSize: 13, marginTop: 4 }}>
                                        {totalQuantity > 0 && <span>数量: {/* SL: */}<Text strong style={{ color: '#111827' }}>{totalQuantity}kg</Text></span>}
                                        <span style={{ marginLeft: 12, marginRight: 12 }}>等級: {/* Grade: */}<Text strong style={{ color: '#111827' }}>{item.grade || "N/A"}</Text></span>
                                        <span>梱包: {/* Đóng gói: */}<Text strong style={{ color: '#111827' }}>{item.package || "N/A"}</Text></span>
                                    </div>

                                    {hasSchedules && (
                                        <>
                                            <Divider style={{ margin: '8px 0 12px 0', borderColor: '#F3F4F6' }} />
                                            <Text style={{ color: '#6B7280', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                納品予定スケジュール {/* LỊCH CUNG CẤP DỰ KIẾN */}
                                            </Text>

                                            <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4, marginTop: 4 }}>
                                                {item.schedules?.map((schedule, scheduleIndex) => (
                                                    <div
                                                        key={scheduleIndex}
                                                        style={{
                                                            backgroundColor: '#F3F4F6',
                                                            borderRadius: 8,
                                                            padding: '6px 12px',
                                                            textAlign: 'center',
                                                            minWidth: 54
                                                        }}
                                                    >
                                                        <div style={{ fontSize: 11, color: '#6B7280' }}>
                                                            {formatDateDDMM(schedule.delivery_date)}
                                                        </div>
                                                        <div style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>
                                                            {schedule.quantity}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </Space>
                            </Card>
                        );
                    })}
                </Space>
            </div>

            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: '#FFFFFF',
                    padding: '12px 16px',
                    boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.05)',
                    zIndex: 100
                }}
            >
                <ButtonCustom
                    title="この提案から注文を作成" /* Tạo Order từ đề xuất này */
                    handlePress={onCreateOrder || (() => { })}
                />
            </div>
        </div>
    );
};